import React from 'react';

const Announcements = () => {
  return (
    <section className="py-12 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Novedades
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 max-w-2xl mx-auto">
          {/* Anuncio Matrícula */}
          <div className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
            <img 
              src="/assets/anuncio_matricula.png" 
              alt="Abierto Plazo de Matrícula"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Announcements;
